import type { Shadows } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { qknColors } from 'app-components/utils/theme';

const defaultTheme = createTheme();

const { soft, strong } = qknColors.shadow;

/**
 * Layer geometry matches mobile `packages/mobile/src/themes/shadow.ts`.
 * Paints come from shared `qknColors.shadow`.
 */
const LIGHT_SOFT = `0px 0px 0px 1px ${soft.ring.light}, 0px 5px 22px 0px ${soft.drop.light}, 0 0 0 0 transparent`;
const LIGHT_STRONG = `0px 0px 0px 1px ${strong.ring.light}, 0px 4px 10px 0px ${strong.drop.light}, 0px 0px 2px 0px ${strong.glow.light}`;
const DARK_SOFT = `0px 0px 0px 1px ${soft.ring.dark}, 0 0 0 0 transparent, 0px 5px 22px 0px ${soft.drop.dark}`;
const DARK_STRONG = `0px 0px 0px 1px ${strong.ring.dark}, 0px 4px 10px 0px ${strong.drop.dark}, 0px 0px 2px 0px ${strong.glow.dark}`;

function shadowScale(softShadow: string, strongShadow: string): Shadows {
  return ['none', ...Array<string>(12).fill(softShadow), ...Array<string>(12).fill(strongShadow)] as Shadows;
}

const lightShadowsOverride: Shadows = shadowScale(LIGHT_SOFT, LIGHT_STRONG);
const darkShadowsOverride: Shadows = shadowScale(DARK_SOFT, DARK_STRONG);

export default function createShadows(mode = 'light'): Shadows {
  const shadowsOverride = mode === 'light' ? lightShadowsOverride : darkShadowsOverride;
  return defaultTheme.shadows.map((shadow, index) => shadowsOverride[index] ?? shadow) as Shadows;
}
